// src/components/admin/OrgManagement.js - Landing page for org-level admin activities
import React, { useState } from 'react';
import { UsersThree } from '@phosphor-icons/react';
import CohortManagement from './CohortManagement';
import './Admin.css';

const OrgManagement = () => {
  const [activeActivity, setActiveActivity] = useState(null);

  if (activeActivity === 'cohorts') {
    return <CohortManagement onBack={() => setActiveActivity(null)} />;
  }

  return (
    <div className="admin-page">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">Org Management</h2>
        <p className="text-sm text-gray-600 mt-1">
          Manage organization-level structures for your tenant.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
          className="card activity-card cursor-pointer transition-colors"
          onClick={() => setActiveActivity('cohorts')}
        >
          <div className="activity-icon-container">
            <UsersThree weight="light" size={28} className="text-blue-600" />
          </div>
          <h4 className="text-lg font-semibold text-gray-800 mb-2">Cohort Management</h4>
          <p className="text-sm text-gray-600 mb-4">
            Group users who went through a class, workshop, or training seminar together, and use
            cohorts to scope reporting access.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrgManagement;
